import React from 'react';
import './Content.css';

function Content({ activeTabContent }) {
  return (
    <div className="content h-full w-full">
      {activeTabContent.component}
    </div>
  );
}

export default Content;
